var render = function render(){var _vm=this,_c=_vm._self._c;return (this.data != '' && this.data != null)?_c('div',{staticClass:"text"},[_c('div',{staticClass:"box",domProps:{"innerHTML":_vm._s(this.highlightedText)}}),_c('PDFViewer',{ref:"pdfViewer"})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }